export const LINK_TYPE_CATEGORY = 'category' as const;
export const LINK_TYPE_NON_CATEGORY = 'non_category' as const;
